export function formatEmpty(text: string): string {
  return text ? ` ${text}` : '';
}
